module.exports = __webpack_public_path__ + "static/media/studio_construction_telehandler_mt_625_manitou_004.5a1c52ba.png";